import PropTypes from "prop-types";
import React from "react";
import { Card, CardTitle } from "react-md";
import _ from "lodash";
import { MSpinner } from "components/Shared";
import { TooltipContext, getTooltipRef } from "../TooltipProvider.tsx";

// TODO: May need to use this for tooltips
const timeEfficiencyClassName = "time-efficiency";

class SummaryCardBusOps extends React.Component {
  static contextType = TooltipContext;

  constructor(props) {
    super(props);
    this.state = {
      hoverClass: Array(9).fill(""),
      // mouseOverTarget: null,
    };
    this.handleTableHover = this.handleTableHover.bind(this);
    this.handleTableBlur = this.handleTableBlur.bind(this);
    this.handleTableClick = this.handleTableClick.bind(this);
    this.tableElem = null;
    this.timeEfficiencyTooltipRef = null; // dont initialize here, context will not be available yet
  }  

  componentDidMount() {
    this.props.getData(this.props.internetUserId, this.props.payPeriodId);
    this.timeEfficiencyTooltipRef = getTooltipRef("Expected Hours/Clock In Hours %", this.context);
  }

  componentDidUpdate(prevProps) {
    if ((this.props.payPeriodId !== prevProps.payPeriodId) || (this.props.internetUserId !== prevProps.internetUserId)) {
      this.props.getData(this.props.internetUserId, this.props.payPeriodId);
      this.props.filterDateCallBack?.(undefined);
    }
    if (!prevProps.refreshCard && this.props.refreshCard) {
      this.props.getData(this.props.internetUserId, this.props.payPeriodId);
    }
  }

  handleTableHover(event) {
    let newCol = Array(9).fill("");
    newCol[event.target.abbr] = "hover";
    this.setState({ hoverClass: newCol });
    // TODO: figure out why this isn't working with MToolTip
    // if (event.target.className.includes(timeEfficiencyClassName)) {
    //   console.log("Expected Hours/Clock In Hours %");
    //   this.setState({ ...this.state, mouseOverObject: {
    //     ...event.raget,
    //     visible: true,
    //     children: <p>Expected Hours/Clock In Hours %</p>
    //   }});
    // }
  }
  handleTableBlur() {
    this.setState({ hoverClass: Array(9).fill("") });
  }
  handleTableClick(event) {
    let day = event.target.abbr;

    if (Number(day) > 7 || day === "") return;
    let filterDate = this.props.data.timeClockDailyHours.timeByDayList.find(x => x.dayOfWeek === Number(day)).date;

    this.props.filterDateCallBack(filterDate);
  }
  render() {
    if (this.props.isFetchingData) {
      return <MSpinner />;
    }

    let auditDailyEfficiencyTooltipRefs = [];
    let auditTotalPassed = 0;
    let auditTotal = 0;

    let hoursByDayMatrix = {
      timeClockDailyHours: _.range(0, 7).map(
        i =>
          Number(this.props.data.timeClockDailyHours?.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      expectedTotalDailyHours: _.range(0, 7).map(
        i =>
          Number(this.props.data.expectedTotalDailyHours?.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      expectedCaseCompletedDailyHours: _.range(0, 7).map(
        i =>
          Number(this.props.data.expectedCaseCompletedDailyHours?.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      expectedAuditDailyHours: _.range(0, 7).map(
        i =>
          Number(this.props.data.expectedAuditDailyHours?.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      expectedPhoneSupportDailyHours: _.range(0, 7).map(
        i =>
          Number(this.props.data.expectedPhoneSupportDailyHours?.timeByDayList.find(
            x => x.dayOfWeek === i
          ).hours).toFixed(2)
      ),
      timeEfficiencyDaily: _.range(0, 7).map(
        i =>
          `${Math.round(this.props.data.timeEfficiencyDaily?.amountByDayList.find(
            x => x.dayOfWeek === i
          ).amount * 100)}%`
      ),
      auditDailyEfficiency: _.range(0, 7).map(
        i =>
          {
            const passed = Number(this.props.data.auditDailyEfficiency?.passedCount?.amountByDayList.find(
              x => x.dayOfWeek === i
            ).amount);
            const total = Number(this.props.data.auditDailyEfficiency?.totalCount?.amountByDayList.find(
              x => x.dayOfWeek === i
            ).amount);

            auditTotal += total;
            auditTotalPassed += passed;

            auditDailyEfficiencyTooltipRefs.push(getTooltipRef(`${passed}/${total}`, this.context));

            return `${total > 0 ? Math.round((passed / total) * 100) : 0}%`;
        }
      ),
    };

    const auditTotalTooltip = getTooltipRef(`${auditTotalPassed}/${auditTotal}`, this.context);

    const { isBusOpsEmployeeTimeLogs } = this.props;

    return (
      <Card className={`card-unnested${isBusOpsEmployeeTimeLogs ? "" : " profile-card"}`}>
        <CardTitle title="Summary" />
        <div className={`${isBusOpsEmployeeTimeLogs ? "qa-table-employee-timelogs" : "qa-table"}`}>
          <table
            ref={elem => {
              if (elem) {
                this.tableElem = elem;
                this.tableElem.addEventListener(
                  "mouseover",
                  this.handleTableHover
                );
                this.tableElem.addEventListener(
                  "mouseout",
                  this.handleTableBlur
                );
                if (this.props.filterDateCallBack)
                  this.tableElem.addEventListener("click", this.handleTableClick);
              }
            }}
          >
            <thead>
              <tr>
                <th className="qa-row" style={{ width: 180 }}>{this.props.employeeName}</th>
                <th className="qa-col">Mon</th>
                <th className="qa-col">Tue</th>
                <th className="qa-col">Wed</th>
                <th className="qa-col">Thu</th>
                <th className="qa-col">Fri</th>
                <th className="qa-col">Sat</th>
                <th className="qa-col">Sun</th>
                <th className="qa-col">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-top">
                <th className="qa-row">Clock In Hours</th>
                {hoursByDayMatrix.timeClockDailyHours.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.timeClockDailyHours[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.timeClockHoursTotal).toFixed(2)}
                </td>
              </tr>
              <tr className="border-top">
                <th className="qa-row">Total Expected Hours</th>
                {hoursByDayMatrix.expectedTotalDailyHours.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.expectedTotalDailyHours[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.expectedTotalHours).toFixed(2)}
                </td>
              </tr>
              <tr className="border-top">
                <th className="qa-row">QAHE Completed</th>
                {hoursByDayMatrix.expectedCaseCompletedDailyHours.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.expectedCaseCompletedDailyHours[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.expectedCaseCompletedTotalHours).toFixed(2)}
                </td>
              </tr>
              <tr className="border-top">
                <th className="qa-row">QAHE Audited</th>
                {hoursByDayMatrix.expectedAuditDailyHours.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.expectedAuditDailyHours[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.expectedAuditTotalHours).toFixed(2)}
                </td>
              </tr>
              <tr className="border-top">
                <th className="qa-row">Phone Support Line</th>
                {hoursByDayMatrix.expectedPhoneSupportDailyHours.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.expectedPhoneSupportDailyHours[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {Number(this.props.data.expectedPhoneSupportTotalHours).toFixed(2)}
                </td>
              </tr>
              <tr className="border-top">
                <th className={`qa-row ${timeEfficiencyClassName}`} ref={this.timeEfficiencyTooltipRef}>Time Efficiency</th>
                {hoursByDayMatrix.timeEfficiencyDaily.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                >
                  {hoursByDayMatrix.timeEfficiencyDaily[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8}>
                  {`${Math.round(this.props.data.timeEfficiencyTotal * 100)}%`}
                </td>
              </tr>
              <tr className="border-top">
                <th className="qa-row">Audit Score</th>
                {hoursByDayMatrix.auditDailyEfficiency.map(
                  (x, i) =>
                    i > 0 && (
                      <td key={i} ref={auditDailyEfficiencyTooltipRefs[i]} className={this.state.hoverClass[i]} abbr={i}>
                        {x}
                      </td>
                    )
                )}
                <td
                  className={`border-right ${this.state.hoverClass[0]}`}
                  abbr={0}
                  ref={auditDailyEfficiencyTooltipRefs[0]}
                >
                  {hoursByDayMatrix.auditDailyEfficiency[0]}
                </td>
                <td className={this.state.hoverClass[8]} abbr={8} ref={auditTotalTooltip}>
                  {`${Math.round(this.props.data.auditTotalEfficiency.amount * 100)}%`}
                </td>
              </tr>
            </tbody>
          </table>
          {/* {this.state.mouseOverTarget && <MToolTip {...this.state.mouseOverTarget} />} */}
        </div>
      </Card>
    );
  }
}

SummaryCardBusOps.defaultProps = {
  isBusOpsEmployeeTimeLogs: false,
};

SummaryCardBusOps.propTypes = {
  data: PropTypes.object.isRequired,
  filterDateCallBack: PropTypes.func,
  isFetchingData: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
  payPeriodId: PropTypes.number.isRequired,
  internetUserId: PropTypes.number.isRequired,
  employeeName: PropTypes.string,
  refreshCard: PropTypes.bool,
  magicMinHeight: PropTypes.bool,
  isBusOpsEmployeeTimeLogs: PropTypes.bool,
};
export default SummaryCardBusOps;